/**
* ErrorHandler.ts
* @author Hector Hernandez (hectorh)
* @copyright Microsoft 2020
* JSLL ErrorHandler.
*/
import { notImplementedWarn } from "./Utils";
var ErrorHandler = /** @class */ (function () {
    function ErrorHandler() {
    }
    ErrorHandler.prototype.init = function () {
        // 1DS error handling will be taken care in WebAnalytics initialization
        // NO OP
        notImplementedWarn("ErrorHandler init");
    };
    return ErrorHandler;
}());
export { ErrorHandler };
//# sourceMappingURL=ErrorHandler.js.map